"use client";
import { jsx as _jsx } from "react/jsx-runtime";
import { Box, useMultiStyleConfig } from "@chakra-ui/react";
import { SkeletonTypes } from "./Skeleton.types";
const Skeleton = ({ type = SkeletonTypes.RECTANGLE, width, height, }) => {
    const styles = useMultiStyleConfig("Skeleton", { type, width });
    return _jsx(Box, { sx: styles.skeletonStyle, w: width, h: height });
};
export default Skeleton;
//# sourceMappingURL=Skeleton.js.map